
import React from 'react';

export default function MissionSection() {
  return (
    <section id="mission" className="py-12 md:py-20 bg-white mb-16 md:mb-24">
      <div className="container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center">
          <div className="mb-12 md:mb-16">
            <p className="text-sm font-medium uppercase tracking-wider mb-4 md:mb-6" style={{ color: 'rgb(11, 61, 145)' }}>
              OUR MISSION
            </p>
            <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#111827] mb-8 md:mb-16 leading-relaxed">
              地域の価値を再編集し、マーケティングで持続可能な未来をつくる
            </h2>
            <p className="text-base md:text-lg text-gray-600 leading-loose max-w-3xl mx-auto mb-12 md:mb-20">
              地域の観光資源や文化、企業の魅力を掘り起こし、データドリブンなマーケティングアプローチで新たな価値を創造します。私たちは地域と企業の持続可能な成長を支援し、未来への架け橋となることを使命としています。
            </p>
          </div>

          {/* 価値観カード */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 md:mb-8">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-blue-100 to-blue-200 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-blue-500 to-blue-600 rounded-full flex items-center justify-center shadow-inner">
                    <i className="ri-lightbulb-line text-2xl md:text-3xl text-white"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#111827] mb-3 md:mb-4">価値創造</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                地域の隠れた魅力を発見し、新たな価値として創造します
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 md:mb-8">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-green-100 to-green-200 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full flex items-center justify-center shadow-inner">
                    <i className="ri-leaf-line text-2xl md:text-3xl text-white"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#111827] mb-3 md:mb-4">持続可能性</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                環境と社会に配慮した持続可能なビジネスモデルを構築します
              </p>
            </div>

            <div className="bg-gray-50 rounded-2xl p-6 md:p-8 text-center group hover:shadow-xl transition-all duration-300">
              <div className="w-20 h-20 md:w-24 md:h-24 mx-auto mb-6 md:mb-8">
                <div className="w-20 h-20 md:w-24 md:h-24 bg-gradient-to-br from-purple-100 to-purple-200 rounded-full flex items-center justify-center group-hover:scale-110 transition-transform duration-300 shadow-lg">
                  <div className="w-16 h-16 md:w-20 md:h-20 bg-gradient-to-br from-purple-500 to-purple-600 rounded-full flex items-center justify-center shadow-inner">
                    <i className="ri-team-line text-2xl md:text-3xl text-white"></i>
                  </div>
                </div>
              </div>
              <h3 className="text-lg md:text-xl font-bold text-[#111827] mb-3 md:mb-4">共創</h3>
              <p className="text-sm md:text-base text-gray-600 leading-relaxed">
                地域の皆様と共に、未来に向けた価値を創造していきます
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
